import { Col } from '../col';
import { Icon } from '../icon';
import { Row } from '../row';
import { Space } from '../space';
import { Text } from '../typography';
import { useFormatDate, useFormatTime } from './hooks';

export type DateOnly = { date: Date };
export type DateTime = {
  dateTime: Date;
};
export type DateTimeRange = {
  dateFrom: Date;
  dateTo: Date;
};

export type TimeInfo = DateOnly | DateTime | DateTimeRange;

type P = {
  display?: { date?: boolean; time?: boolean };
  fontSize?: 'small';
  isStrikeThrough?: boolean;
  timeInfo: TimeInfo;
};

const defaultDisplay = {};

const DateTimeInfo = ({
  display: { date = true, time = true } = defaultDisplay,
  fontSize,
  isStrikeThrough,
  timeInfo,
}: P) => {
  const formatDateText = useFormatDate();
  const formatTimeText = useFormatTime();
  const formatedTimeText = formatTimeText({ timeInfo });

  return (
    <Row gutter="ms">
      {date ? (
        <Col>
          <Space size="xxs">
            {/* TODO: icon inherits color from parent `a` and appears blue, we need to override its color */}
            <Icon color="text" icon="calendar-month-line" size="extra-small" />
            <Text delete={isStrikeThrough} size={fontSize}>
              {formatDateText({ timeInfo })}
            </Text>
          </Space>
        </Col>
      ) : null}

      {formatedTimeText && time ? (
        <Col>
          <Space size="xxs">
            {/* TODO: icon inherits color from parent `a` and appears blue, we need to override its color */}
            <Icon color="text" icon="time-line" size="extra-small" />
            <Text delete={isStrikeThrough} size={fontSize}>
              {formatedTimeText}
            </Text>
          </Space>
        </Col>
      ) : null}
    </Row>
  );
};

export default DateTimeInfo;
